import { Component } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { IReuploadReferencesDialogData } from 'editing-tool/src/app/shared/components/paper/steps/references/reupload-references-dialog/reupload-references-dialog-data';
import { FileValidationModel } from 'sc-common';

@Component({
    templateUrl: './reupload-references-dialog.component.html',
    standalone: false
})
export class ReuploadReferencesDialogComponent {

    public readonly config: IReuploadReferencesDialogData;

    public fileValidationRules: FileValidationModel;

    public requestInProcess = false;

    constructor(
        dialogConfig: DynamicDialogConfig,
        private readonly _dialogRef: DynamicDialogRef) {

        this.config = dialogConfig.data;
    }

    public onUploadStarted(): void {
        this.requestInProcess = true;
    }

    public onUploadCompleted(): void {
        this.requestInProcess = false;

        this._dialogRef.close(true);
    }
}
